import { IAnalyzerMission } from "../interfaces/analyzer-mission.interface";
import { Analyzer } from "./analyzer.model";
import { Gateway } from "./gateway.model";

export class AnalyzerMission implements IAnalyzerMission {
  analyzerpk: number;
  analyzerId: string;
  gatewayId: string;
  fieldprotocolName: string;
  createdOn: string;
  createdBy: string;
  changedOn: string;
  changedBy: string;
  handleFlyingH2?: boolean;

  analyzer: Analyzer;
  gateway: Gateway;

  constructor(analyzer: IAnalyzerMission) {
    Object.keys(analyzer).map(key => this[key] = analyzer[key]);
  }

  get lastUpdatedBy(): string {
    return this.changedBy ? this.changedBy :
              this.createdBy ? this.createdBy : '';
  }

  get lastUpdatedOn(): string {
    return this.changedOn ? this.changedOn : this.createdOn;
  }

  get hasGateway(): boolean {
    return this.gateway && !(this.gateway.isNoGateway);
  }

  setEquipments(params: SetAnalyzerMissionEquipmentsParams) {
    this.analyzer = params.analyzers.find(analyzer => analyzer.analyzerId === this.analyzerId);
    this.gateway = params.gateways.find(gateway => gateway.gatewayId === this.gatewayId);
  }
}

export interface SetAnalyzerMissionEquipmentsParams {
  analyzers: Analyzer[];
  gateways: Gateway[];
}